export const getCouponPrice = (promotion, price) => {
  if (!promotion) {
    return price;
  }
  const { percent_off, amount_off } = promotion.coupon;
  if (percent_off) {
    return price * (1 - percent_off / 100);
  }

  if (amount_off) {
    return price - amount_off;
  }
};
